module.exports = __webpack_public_path__ + "static/img/far5_active.78f5abf1.png";